import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { ExecutiveNotifier } from '../notifiers/executive-notifier';
import { ExecutiveState } from '../states/executive-state';

@Injectable({ providedIn: 'root' })
export class ExecutiveProvider extends BaseProvider<ExecutiveNotifier, ExecutiveState> {
  constructor() {
    super(ExecutiveNotifier);
  }
}
